import { ChipPropType, ColorsType } from '../types';

const bgColors: ColorsType = {
  Prepaid: 'bg-teal-light',
  Closed: 'bg-yellow-dark bg-opacity-20',
};

const AccountChip = ({ accountStatus, prepaid, prepaidLabel }: ChipPropType) => {
  const chipText = prepaid ? prepaidLabel : 'Closed';
  const shouldShow = accountStatus === 'INACTIVE' || prepaid;
  const chipBackground = chipText === 'Closed' ? bgColors.Closed : bgColors.Prepaid;

  return shouldShow ? (
    <p
      aria-hidden="true"
      className={`${chipBackground} text-gray-dark leading-none h-32 w-fit px-14 py-8 rounded-full`}
    >
      {chipText}
    </p>
  ) : null;
};

export { AccountChip };
